import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useBookmakerFromCode = (bookmakerCode: string) => {
  const bookmakers = useBookmakersAll();

  return useMemo(() => bookmakers.find(bookmaker => bookmaker.code === bookmakerCode), [bookmakers, bookmakerCode]);
};
